import { render, staticRenderFns } from "./InPageNavigationBase.vue?vue&type=template&id=9f767a8e"
import script from "./InPageNavigationBase.vue?vue&type=script&lang=js"
export * from "./InPageNavigationBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports